import { SignInButton } from './SignInButton';
import { cn } from '@/lib/utils';

export function TopBar({ className }: { className?: string }) {
  return (
    <header
      className={cn(
        'flex shrink-0 items-center justify-between px-4 py-3 desktop:px-6 desktop:py-4',
        className,
      )}
    >
      <div className="h-6"></div>
      <SignInButton />
    </header>
  );
}
